import { render, staticRenderFns } from "./emailPreviewPo.vue?vue&type=template&id=23b82e7a&scoped=true&"
import script from "./emailPreviewPo.vue?vue&type=script&lang=js&"
export * from "./emailPreviewPo.vue?vue&type=script&lang=js&"
import style0 from "./emailPreviewPo.vue?vue&type=style&index=0&id=23b82e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b82e7a",
  null
  
)

export default component.exports